<template>
  <div class="specialist-mode">
    <el-row class="mode-header" type="flex" justify="space-between" align="middle">
      <el-checkbox-group v-model="checkboxValue" @change="axisHandler">
        <el-checkbox v-for="v in checkboxOp" :key="v" :label="v"></el-checkbox>
      </el-checkbox-group>
      <div class="flow">
        <button class="button-style" @click="clearbBroundEvent">清除本底</button>
      </div>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12" v-for="item in echartsObj" :key="item.id">
        <div class="echart-box">
          <v-chart :options="item.options" :autoresize="true"></v-chart>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { clearBground } from '@/api/devices';
import singleDeviceMixin from '@/mixins/singleDeviceMixin.js';
import { expertBar1, expertLine1 } from '@/echartOption/expert';

const xAxisData = [
  '0.5-1.0',
  '1.0-1.5',
  '1.5-2.0',
  '2.0-2.5',
  '2.5-3.0',
  '3.0-3.5',
  '3.5-4.0',
  '4.0-4.5',
  '4.5-5.0',
  '5.0-5.5',
  '5.5-6.0',
  '6.0-10.00',
  '>10.00'
];

export default {
  name: 'Expert',
  props: {
    pointId: String
  },
  mixins: [singleDeviceMixin],
  data() {
    return {
      checkboxOp: ['0.5-1.0', '1.0-1.5', '2.0-2.5', '2.5-3.0'],
      checkboxValue: ['0.5-1.0', '1.0-1.5', '2.0-2.5', '2.5-3.0'],
      parSizes: [
        '0510',
        '1015',
        '1520',
        '2025',
        '2530',
        '3035',
        '3540',
        '4045',
        '4550',
        '5055',
        '5560',
        '60100',
        'Ab100'
      ],
      unSelect: [],
      echartsObj: {
        parType: {
          options: expertBar1({ title: { text: '粒子数(个/秒)' } })
        },
        parAll: {
          options: expertLine1({ title: { text: '总粒子数(个/秒)' } })
        },
        bioType: {
          options: expertBar1({ title: { text: '荧光粒子数(个/秒)' } })
        },
        bioAll: {
          options: expertLine1({ title: { text: '荧光总粒子数(个/秒)' } })
        }
      }
    };
  },
  methods: {
    axisHandler(newVal) {
      this.unSelect = this.checkboxOp.filter(e => {
        return newVal.indexOf(e) === -1;
      });
      const copyxAxis = JSON.parse(JSON.stringify(xAxisData));
      this.unSelect.forEach(e => {
        copyxAxis.splice(copyxAxis.indexOf(e), 1);
      });
      this.echartsObj.parType.options.xAxis.data = copyxAxis;
      this.echartsObj.bioType.options.xAxis.data = copyxAxis;
    },
    clearbBroundEvent() {
      clearBground({ sn: this.sn, type: 'bio', deviceType: this.deviceType }).then(res => {
        if (res) {
          this.$message({
            type: 'success',
            message: '修改成功'
          });
        }
      });
    },
    updateData(newVal) {
      const timestamp = newVal.beginTime;
      const { bioMod } = newVal.mods;
      const parCounts = [];
      const bioCounts = [];
      // 更新图表
      const len = this.echartsObj.bioAll.options.series[0].data.length;
      const limitLen = 200;
      if (len > limitLen) {
        // 防止内存溢出
        this.echartsObj.bioAll.options.series[0].data.shift();
        this.echartsObj.bioAll.options.series[1].data.shift();
        this.echartsObj.parAll.options.series[0].data.shift();
        this.echartsObj.parAll.options.series[1].data.shift();
      }
      this.echartsObj.bioAll.options.series[0].data.push([timestamp, bioMod.bioOrLarge]);
      this.echartsObj.bioAll.options.series[1].data.push([timestamp, bioMod.bioOrSmall]);
      this.echartsObj.parAll.options.series[0].data.push([timestamp, bioMod.parOrLarge]);
      this.echartsObj.parAll.options.series[1].data.push([timestamp, bioMod.parOrSmall]);

      this.echartsObj.parType.options.series.data.splice(0);
      this.parSizes.forEach((x, i) => {
        if (this.unSelect.indexOf(x) === -1) {
          parCounts.push(bioMod[`parOr${i + 1}`]);
        }
      });
      this.echartsObj.parType.options.series.data.push(...parCounts);
      this.echartsObj.bioType.options.series.data.splice(0);
      this.parSizes.forEach((x, i) => {
        if (this.unSelect.indexOf(x) === -1) {
          bioCounts.push(bioMod[`bioOr${i + 1}`]);
        }
      });
      this.echartsObj.bioType.options.series.data.push(...bioCounts);
    }
  }
};
</script>

<style lang="scss">
.specialist-mode {
  padding: 10px 20px;
  .echart-box {
    width: 100%;
    min-height: 380px;
    height: 40vh;
    margin: 5px;
    padding: 1px;
    @include border-style-1;
    background-color: #112132;
  }
  .mode-header {
    padding: 10px 20px;
  }
  .flow {
    float: right;
    color: $normal-color;
    font-size: 20px;
    span {
      display: inline-block;
      margin: 0 50px 0 0;
    }
  }
}
</style>
